module.exports = __webpack_public_path__ + "master-logo.726974b4.svg";